import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=4014fd52&scoped=true&"
import script from "./Link.vue?vue&type=script&lang=js&"
export * from "./Link.vue?vue&type=script&lang=js&"
import style0 from "../assets/StyleSheet/About.css?vue&type=style&index=0&id=4014fd52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4014fd52",
  null
  
)

export default component.exports